module.exports = __webpack_public_path__ + "018998955f60a9ed318b44346821fd93.svg";